module.exports = __webpack_public_path__ + "public/media/4.b5dd1c38.wav";